export default {
  inventory: 'Инвентарь',
  tokens_in_wallet: 'Хотите перевести {tokenType} в свой кошелёк?',
  tokens_in_wallet_success: '{tokenType} успешно переведен в ваш кошелёк!',
  transfer: 'Перевести',
  vd_in_team: 'Хотите перевести ВД на счёт своей команды?',
  vd_in_team_success: 'ВД успешно переведены на счёт вашей команды!',
}
